import { format, subDays } from "date-fns"
import { Pipeline, Brand, Geography, Language } from "db"
import getPipelinePublicUrl from "app/pipelines/services/getPipelinePublicUrl"

type PipelineGoogleAnalyticsUrlProps = Pick<Pipeline, "name"> & {
  brand: Pick<Brand, "name" | "googleDashboardUrl">
  geography: Pick<Geography, "name">
  language: Pick<Language, "code">
}

// Returns pipeline URL to Google Analytics dashboard
export default function getPipelineGoogleAnalyticsUrl(pipeline: PipelineGoogleAnalyticsUrlProps) {
  const { brand } = pipeline
  const publicUrl = getPipelinePublicUrl(pipeline)

  const params = new URLSearchParams()
  const endDate = new Date()
  const startDate = subDays(endDate, 30)

  params.set("_u.date00", format(startDate, "yyyyMMdd"))
  params.set("_u.date01", format(endDate, "yyyyMMdd"))
  params.set("explorer-segmentExplorer.segmentId", "analytics.landingPagePath")
  params.set("explorer-table.filter", publicUrl.pathname.replace(/\//g, "~2F"))

  if (brand.googleDashboardUrl) {
    return new URL(`${brand.googleDashboardUrl.replace(/\/$/g, "")}/${params.toString()}/`)
  } else {
    return null
  }
}

export type { PipelineGoogleAnalyticsUrlProps }
